var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon35(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 22.1412C13.9976 21.2863 13.0686 20.3491 12.2225 19.3393C10.953 17.823 9.44531 15.5647 9.44531 13.4127C9.44476 12.3137 9.77026 11.2392 10.3806 10.3253C10.9909 9.41129 11.8587 8.69893 12.8741 8.27833C13.8894 7.85773 15.0067 7.74779 16.0846 7.96243C17.1624 8.17708 18.1524 8.70665 18.9292 9.48413C19.4463 9.99899 19.8563 10.6113 20.1352 11.2857C20.4141 11.96 20.5566 12.683 20.5543 13.4127C20.5543 15.5647 19.0466 17.823 17.777 19.3393C16.931 20.3491 16.002 21.2863 14.9998 22.1412ZM14.9998 11.0322C14.3684 11.0322 13.763 11.283 13.3165 11.7295C12.8701 12.1759 12.6193 12.7814 12.6193 13.4127C12.6193 14.0441 12.8701 14.6496 13.3165 15.096C13.763 15.5424 14.3684 15.7932 14.9998 15.7932C15.6311 15.7932 16.2366 15.5424 16.683 15.096C17.1295 14.6496 17.3803 14.0441 17.3803 13.4127C17.3803 12.7814 17.1295 12.1759 16.683 11.7295C16.2366 11.283 15.6311 11.0322 14.9998 11.0322Z",
    fill: "url(#paint0_linear_3735_14600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3735_14600",
    x1: 14.9998,
    y1: 5.28404,
    x2: 14.9998,
    y2: 24.4269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon35);
export default __webpack_public_path__ + "static/media/icon35.1c7ee5f75418fce8516a4533b0504855.svg";
export { ForwardRef as ReactComponent };